import { post } from '@/services/infrastructure/api.service'

const createSaftExport = async (orgNo: string, from: string, to: string) => await post('/saft/export', { }, {},{ orgNo: orgNo,fromDate: from, toDate: to })
const importSaftExport = async (file: File) => await post('/saft/import', createFormData(file))

function createFormData(file: File): FormData {
    const form = new FormData()
    form.append(
        'file',
        file
    )
    return form
}

export { createSaftExport, importSaftExport }
